/**
 * G711U(u-law) - PCM converter
 */
const SIGN_BIT = 0x80
const QUANT_MASK = 0x0f
const SEG_SHIFT = 0x04
const SEG_MASK = 0x70

// const seg_end = new Uint16Array([0x1F, 0x3F, 0x7F, 0xFF, 0x1FF, 0x3FF, 0x7FF, 0xFFF]);
const seg_end = new Uint16Array([0xff, 0x1ff, 0x3ff, 0x7ff, 0xfff, 0x1fff, 0x3fff, 0x7fff])

// const seg_uend = new Uint16Array([0x3F, 0x7F, 0xFF, 0x1FF, 0x3FF, 0x7FF, 0xFFF, 0x1FFF]);
const alaw_compress_table = [
  1, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6,
  6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7,
  7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
  7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
]

const cClip = 32635

function search(val, table, size) {
  for (let i = 0; i < size; i++) {
    if (val <= table[i]) return i
  }
  return size
}

function linear2alawsample(sample) {
  let sign
  let exponent
  let mantissa
  let s
  sign = (~sample >> 8) & 0x80
  if (!(sign === 0x80)) {
    sample = -sample
  }
  if (sample > cClip) {
    sample = cClip
  }
  if (sample >= 256) {
    exponent = alaw_compress_table[(sample >> 8) & 0x7f]
    mantissa = (sample >> (exponent + 3)) & 0x0f
    s = (exponent << 4) | mantissa
  } else {
    s = sample >> 4
  }
  s ^= sign ^ 0x55
  return s
}

export function alawFromPCM2(data) {
  let res = new Uint8Array()
  if (data instanceof Int16Array) {
    res = new Uint8Array(data.length)
    for (let i = 0; i < data.length; i++) {
      res[i] = linear2alawsample(data[i])
    }
  } else if (data instanceof Int8Array) {
    const count = data.length / 2
    res = new Uint8Array(count)
    let j = 0
    for (let i = 0; i < count; i++) {
      let sample = (data[j++] & 0xff) | (data[j++] << 8)
      res[i] = linear2alawsample(sample)
    }
  }
  return res
}

/**
 *
 * @param {Int16Array} data
 * @returns
 */
function linear2alaw(pcm_val) {
  let mask
  let seg
  let aval
  if (pcm_val >= 0) {
    mask = 0xd5 /* sign (7th) bit = 1 */
  } else {
    mask = 0x55 /* sign bit = 0 */
    pcm_val = pcm_val * -1 - 1
  }
  /* Convert the scaled magnitude to segment number. */
  seg = search(pcm_val, seg_end, 8)
  /* Combine the sign, segment, and quantization bits. */
  if (seg >= 8) /* out of range, return maximum value. */ return 0x7f ^ mask
  else {
    aval = seg << SEG_SHIFT
    if (seg < 2) aval |= (pcm_val >> 4) & QUANT_MASK
    else aval |= (pcm_val >> (seg + 3)) & QUANT_MASK
    return aval ^ mask
  }
}

/**
 *
 * @param data
 * @returns
 */
export function alawFromPCM(data) {
  let dest = new Uint8Array(data.length)
  for (let i = 0, k = 0; i < data.length; i++) {
    dest[k++] = linear2alaw(data[i])
  }
  return dest
}
function alaw2linear(a_val) {
  let t
  let seg
  a_val ^= 0x55
  t = (a_val & QUANT_MASK) << 4
  seg = (a_val & SEG_MASK) >> SEG_SHIFT
  switch (seg) {
    case 0:
      t += 8
      break
    case 1:
      t += 0x108
      break
    default:
      t += 0x108
      t <<= seg - 1
  }
  return a_val & SIGN_BIT ? t : -t
}

/**
 * Convert an A-law value to linear PCM
 * @param data
 * @param bit
 * @returns
 */
export function alawToPCM(data, bit = 16) {
  let typedArray = bit === 16 ? Int16Array : Int8Array
  let dest = new typedArray(data.length)
  for (let i = 0, k = 0, len = data.length; i < len; i++) {
    dest[k++] = alaw2linear(data[i] & 0xff)
  }
  return dest
}
export function alawToPCM2(data, bit = 16) {
  let temp
  if (
    data[0] == 0x00 &&
    data[1] == 0x01 &&
    (data[2] & 0xff) == (data.length - 4) / 2 &&
    data[3] == 0x00
  ) {
    temp = new Uint8Array(data.length - 4)
    for (let i = 0, k = 0; i < data.length - 4; i++) {
      temp[k++] = data[i + 4]
    }
  } else {
    temp = data
  }
  return alawToPCM(temp, bit)
}
